import React from "react";
import "./LiveChat.css"; // Import CSS file
import { MessageOutlined } from "@ant-design/icons"; // Chat Icon

const LiveChat = () => {
    const openChat = () => {
        window.open("https://wa.me/9333333092", "_blank"); // ✅ Correct WhatsApp link
    };

    return (
        <div className="liveChatBox" onClick={openChat}>
            <MessageOutlined className="chatIcon" />
        </div>
    );
};

export default LiveChat;
